"use strict";

exports.__esModule = true;
exports.default = Breadcrumbs;
var _preact = require("preact");
var Breadcrumb = function Breadcrumb(props) {
  var getFolder = props.getFolder,
    title = props.title,
    isLast = props.isLast;
  return (0, _preact.h)(_preact.Fragment, null, (0, _preact.h)("button", {
    type: "button",
    className: "uppy-u-reset uppy-c-btn",
    onClick: getFolder
  }, title), !isLast ? ' / ' : '');
};
function Breadcrumbs(props) {
  var _getFolder = props.getFolder,
    title = props.title,
    breadcrumbsIcon = props.breadcrumbsIcon,
    breadcrumbs = props.breadcrumbs;
  return (0, _preact.h)("div", {
    className: "uppy-Provider-breadcrumbs"
  }, (0, _preact.h)("div", {
    className: "uppy-Provider-breadcrumbsIcon"
  }, breadcrumbsIcon), breadcrumbs.map(function (directory, i) {
    return (0, _preact.h)(Breadcrumb, {
      key: directory.id,
      getFolder: function getFolder() {
        return _getFolder(directory.requestPath, directory.name);
      },
      title: i === 0 ? title : directory.name,
      isLast: i + 1 === breadcrumbs.length
    });
  }));
}